import {
  Configuration,
  BaseUserApi,
  TestApi,
  CategoryApi,
  GoodsApi,
  DesktopApi,
  CouponTypeApi,
  CouponApi,
  UserApi,
  ConfigApi,
  BenefitApi,
  UserLevelRuleApi,
  RechargeApi,
  PointsRuleApi,
  InviteRuleApi,
  SignRuleApi,
  WifiApi,
  BillApi,
  PointsRecordApi,
  CoinsRecordApi,
  StoreNoticeApi,
  WaitingDeskApi,
  StatisticsApi,
  PointsApplyApi,
  OrderDesktopApi,
} from '@/api';
import { axios } from 'hpsfir-managebase-ui';

interface BaseApi {
  baseUrl: string;
  uploadFileUrl: string;
  baseUserApi: BaseUserApi;
  testApi: TestApi;
  categoryApi: CategoryApi;
  goodsApi: GoodsApi;
  desktopApi: DesktopApi;
  couponTypeApi: CouponTypeApi;
  couponApi: CouponApi;
  userApi: UserApi;
  configApi: ConfigApi;
  benefitApi: BenefitApi;
  userLevelRuleApi: UserLevelRuleApi;
  rechargeApi: RechargeApi;
  pointsRuleApi: PointsRuleApi;
  inviteRuleApi: InviteRuleApi;
  signRuleApi: SignRuleApi;
  wifiApi: WifiApi;
  billApi: BillApi;
  pointsRecordApi: PointsRecordApi;
  coinsRecordApi: CoinsRecordApi;
  storeNoticeApi: StoreNoticeApi;
  waitingDeskApi: WaitingDeskApi;
  statisticsApi: StatisticsApi;
  pointsApplyApi: PointsApplyApi;
  orderDesktopApi: OrderDesktopApi;
}

const api: BaseApi = {

} as any;

export const initApi = (basePath: string) => {
  const apiConfig = new Configuration({
    basePath,
  });
  api.baseUrl = basePath;
  api.uploadFileUrl = '/upload/file';
  api.baseUserApi = new BaseUserApi(apiConfig, basePath, axios);
  api.testApi = new TestApi(apiConfig, basePath, axios);
  api.categoryApi = new CategoryApi(apiConfig, basePath, axios);
  api.goodsApi = new GoodsApi(apiConfig, basePath, axios);
  api.desktopApi = new DesktopApi(apiConfig, basePath, axios);
  api.couponTypeApi = new CouponTypeApi(apiConfig, basePath, axios);
  api.couponApi = new CouponApi(apiConfig, basePath, axios);
  api.userApi = new UserApi(apiConfig, basePath, axios);
  api.configApi = new ConfigApi(apiConfig, basePath, axios);
  api.benefitApi = new BenefitApi(apiConfig, basePath, axios);
  api.userLevelRuleApi = new UserLevelRuleApi(apiConfig, basePath, axios);
  api.rechargeApi = new RechargeApi(apiConfig, basePath, axios);
  api.pointsRuleApi = new PointsRuleApi(apiConfig, basePath, axios);
  api.inviteRuleApi = new InviteRuleApi(apiConfig, basePath, axios);
  api.signRuleApi = new SignRuleApi(apiConfig, basePath, axios);
  api.wifiApi = new WifiApi(apiConfig, basePath, axios);
  api.billApi = new BillApi(apiConfig, basePath, axios);
  api.pointsRecordApi = new PointsRecordApi(apiConfig, basePath, axios);
  api.coinsRecordApi = new CoinsRecordApi(apiConfig, basePath, axios);
  api.storeNoticeApi = new StoreNoticeApi(apiConfig, basePath, axios);
  api.waitingDeskApi = new WaitingDeskApi(apiConfig, basePath, axios);
  api.statisticsApi = new StatisticsApi(apiConfig, basePath, axios);
  api.pointsApplyApi = new PointsApplyApi(apiConfig, basePath, axios);
  api.orderDesktopApi = new OrderDesktopApi(apiConfig, basePath, axios);
};

export const useApi = () => api;

